import { Link } from "react-router-dom";
import { Smartphone, LayoutDashboard, Globe, ArrowUpRight } from "lucide-react";
import { C } from "./ui";
import { Wordmark, Serif, Label } from "../consumer/ui";

const GROUPS = [
  {
    key: "consumer", title: "Consumer PWA", icon: Smartphone, to: "/app", accent: C.red,
    note: "Mobile · sign in, then use the numbered buttons",
    screens: ["Auth", "Home (panic)", "Emergency Mode", "Profile enrichment", "Household", "Self-test", "Notices", "Family Locate"],
  },
  {
    key: "admin", title: "Admin Console", icon: LayoutDashboard, to: "/prototype/admin", accent: C.navy,
    note: "Desktop · product filter in the header, sidebar to navigate",
    screens: ["Ops Console", "Incident detail", "Customers", "Customer detail", "Partners", "Leads funnel", "Communications", "Reports", "Import / Migration", "Settings"],
  },
  {
    key: "marketing", title: "Marketing", icon: Globe, to: "/prototype/marketing", accent: C.green,
    note: "Public · toggle Consumer / Commercial",
    screens: ["ResQ1 Consumer landing", "ResQconnect Commercial"],
  },
];

export default function PrototypeHub() {
  const total = GROUPS.reduce((n, g) => n + g.screens.length, 0);
  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(160deg,#0d1826,#0B1E3B 60%,#12263f)`, fontFamily: "'Inter', system-ui, sans-serif", padding: "0 0 60px" }} data-testid="prototype-hub">
      <header style={{ padding: "20px 32px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}><Wordmark light /></header>

      <div style={{ maxWidth: 1080, margin: "0 auto", padding: "56px 32px 0" }}>
        <Label style={{ color: "rgba(255,255,255,0.55)", display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ width: 24, height: 1, background: C.red }} /> Phase A · clickable prototype · {total} screens
        </Label>
        <Serif size={46} style={{ color: "#fff", maxWidth: 700 }}>The whole prototype, <em style={{ color: "rgba(255,255,255,0.55)" }}>in one place.</em></Serif>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 16, marginTop: 16, maxWidth: 560, lineHeight: 1.6 }}>
          Every surface, seeded with real names from the master client list. Wireframes only — no live dispatch, no emails, no real data written.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 20, marginTop: 44 }}>
          {GROUPS.map((g) => {
            const Icon = g.icon;
            const external = g.to === "/app";
            const inner = (
              <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: 26, height: "100%", cursor: "pointer", transition: "border-color 0.2s, background 0.2s" }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = g.accent; e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"; e.currentTarget.style.background = "rgba(255,255,255,0.04)"; }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: `${g.accent}22`, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon size={22} color={g.accent} /></div>
                  <ArrowUpRight size={20} color="rgba(255,255,255,0.5)" />
                </div>
                <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>{g.title}</div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 4, marginBottom: 16 }}>{g.screens.length} screens · {g.note}</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {g.screens.map((s) => (
                    <span key={s} style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", padding: "4px 9px", borderRadius: 999 }}>{s}</span>
                  ))}
                </div>
              </div>
            );
            return external
              ? <a key={g.key} href={g.to} data-testid={`hub-${g.key}`} style={{ textDecoration: "none" }}>{inner}</a>
              : <Link key={g.key} to={g.to} data-testid={`hub-${g.key}`} style={{ textDecoration: "none" }}>{inner}</Link>;
          })}
        </div>
      </div>
    </div>
  );
}
